import { plainToInstance } from 'class-transformer';
import { BaseService, BaseServiceConstructor } from 'api/services/base.service';

import { Property } from 'types/models';
import { ServiceLine } from 'types/models';

export class ServiceLineService extends BaseService {
  constructor({ serviceUrls, token, tenantName }: BaseServiceConstructor) {
    super({ serviceUrls, token, tenantName });
  }

  async getServiceLine(serviceLineId: ServiceLine['id']): Promise<ServiceLine> {
    const { data } = await this.publicHttpClient.get<ServiceLine>(
      `/serviceLines/${serviceLineId}`,
      {
        withCredentials: false,
      }
    );
    return plainToInstance(ServiceLine, data);
  }

  async getServiceLineProperty(
    serviceLineId: ServiceLine['id'],
    propertyId: Property['id']
  ): Promise<Property> {
    const { data } = await this.publicHttpClient.get<Property>(
      `/serviceLines/${serviceLineId}/properties/${propertyId}`,
      {
        withCredentials: false,
      }
    );
    return data;
  }

  async getServiceLineProperties(serviceLineId: ServiceLine['id']): Promise<Property[]> {
    const { data } = await this.publicHttpClient.get<Property[]>(
      `/serviceLines/${serviceLineId}/properties`,
      {
        withCredentials: false,
      }
    );
    return data;
  }
}
